/**
 * Shared formatters for audit-log before/after values and field labels.
 * Extracted from the duplicate `fmt`/`label` and `formatValue`/`formatField`
 * functions in VenueAuditLog, StaffAuditLog, and venues/detail/AuditLog
 * (BON-214 slice 2).
 *
 * The label regex is a superset of the per-component versions: it also handles
 * snake_case field names (the camelCase-only path is identical — the `/_/g`
 * replace is a no-op when no underscores are present).
 */

/**
 * Format a raw audit field value for display.
 * - null / undefined  → "—"
 * - string            → the string as-is
 * - number / boolean  → String(v)
 * - anything else     → JSON.stringify(v)
 */
export function formatAuditValue(v: unknown): string {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') return String(v);
  return JSON.stringify(v);
}

/**
 * Convert a camelCase or snake_case field name to a human-readable label.
 * Examples:
 *   "venueNotes"    → "Venue Notes"
 *   "addressLine1"  → "Address Line1"
 *   "hire_date"     → "Hire date"  (only first char is uppercased)
 */
export function formatAuditFieldLabel(field: string): string {
  return field
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}
